import { render, staticRenderFns } from "./DesignatedPosition.vue?vue&type=template&id=6547762f&scoped=true"
import script from "./DesignatedPosition.vue?vue&type=script&lang=js"
export * from "./DesignatedPosition.vue?vue&type=script&lang=js"
import style0 from "./DesignatedPosition.vue?vue&type=style&index=0&id=6547762f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6547762f",
  null
  
)

export default component.exports